import { Conversation } from './types/Conversation';
import { MakeCall } from './createMakeCall';

const cancelConversation = (makeCall: MakeCall) => (conversationId: number) =>
  makeCall<Conversation>(
    'PUT',
    `/api/v2/conversation/${conversationId}/cancel`,
  );
export { cancelConversation };
